import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './assets/css/fonts.css';

import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import Home from './pages/Home.js';
import GetStarted from './pages/Starting.js';
import Login from './pages/Login.js';
import LearningDashboard from './pages/LearningDashboard.js';
import FlashCardGame from './pages/FlashCardGame.js';
import VocabTestGame from './pages/VocabTestGame.js';
import StoryPage from './pages/StoryPage.js';
import SongPage from './pages/SongPage.js';
import ReviewGame from './pages/ReviewGame.js';
import ListeningGame from './pages/ListeningGame.js';
import TermsOfService from './pages/TermsOfService.js';
import NotFound from './pages/NotFound.js';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Home />} />
            <Route path="/get-started" element={<GetStarted />} />
            <Route path="/signup" element={<GetStarted />} />
            <Route path="/register" element={<GetStarted />} />
            <Route path="/login" element={<Login />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/terms" element={<TermsOfService />} />

            {/* Protected authenticated routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <LearningDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/flashcards"
              element={
                <ProtectedRoute>
                  <FlashCardGame />
                </ProtectedRoute>
              }
            />
            <Route
              path="/testing"
              element={
                <ProtectedRoute>
                  <VocabTestGame />
                </ProtectedRoute>
              }
            />
            <Route
              path="/story"
              element={
                <ProtectedRoute>
                  <StoryPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/song"
              element={
                <ProtectedRoute>
                  <SongPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/review"
              element={
                <ProtectedRoute>
                  <ReviewGame />
                </ProtectedRoute>
              }
            />
            <Route
              path="/listening"
              element={
                <ProtectedRoute>
                  <ListeningGame />
                </ProtectedRoute>
              }
            />

            {/* 404 Catch-All Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
